import React, { useState } from "react";
import { useProductData } from "@/zustand/productStore";
import { useCartData } from "@/zustand/cartStore";
import TagIcon from "@/utils/images/tagIcon";
import RemoveIcon from "@/utils/images/RemoveIcon";

const DiscountInput = ({ marginTop }) => {
  const { handleSetDiscountCode, handleRemoveDiscountCode, discountCode } = useCartData();
  const productData = useProductData();
  const [codeValue, setCodeValue] = useState("");
  const [error, setError] = useState("");
  const discountSettings = productData.discount_codes;
  const base = window?.post_template?.checkout_v4_summary;

  const handleDiscountApply = () => {
    if (codeValue.toUpperCase() === discountSettings.discount_code.toUpperCase()) {
      if (discountSettings.code_has_expiration_date && discountSettings.discount_code_expiration_date) {
        const [day, month, year] = discountSettings.discount_code_expiration_date.split("/");
        const expirationDate = new Date(year, month - 1, day);
        expirationDate.setHours(23, 59, 59, 999);
        const currentDate = new Date();

        if (currentDate > expirationDate) {
          setError(base?.tr_checkout_v4_discount_expired);
          return;
        }
      }
      handleSetDiscountCode(codeValue);
      setError("");
    } else {
      setError(base?.tr_checkout_v4_discount_error);
    }
    setCodeValue("");
  };

  const handleRemoveDiscount = () => {
    handleRemoveDiscountCode();
    setCodeValue("");
    setError("");
  };

  return (
    <>
      {discountSettings && (
        <>
          <div className="discount__inputContainer" style={{ marginTop: marginTop ?? "" }}>
            <div className={`discount__inputContainer__input input--text`}>
              <input
                className="discount__inputContainer__styledInput"
                value={codeValue}
                onChange={(e) => setCodeValue(e.target.value)}
                placeholder={base?.tr_checkout_v4_discount_placeholder}
              />
            </div>
            <button
              type="button"
              className="discount__inputContainer__applyButton"
              onClick={() => {
                codeValue && handleDiscountApply();
              }}
            >
              <span className="discount__inputContainer__applyButton__text">{base?.tr_checkout_v4_discount_apply}</span>
            </button>
          </div>
          {error && (
            <div className="discount__error" style={discountCode ? { marginBottom: "8px" } : {}}>
              {error}
            </div>
          )}
          <div className="discount__pill__container">
            {discountCode && (
              <div className="discount__pill">
                <TagIcon className="discount__pill__tag" />
                <span className="discount__pill__text">{discountCode}</span>
                <div className="discount__pill__closeBtn" onClick={handleRemoveDiscount}>
                  <RemoveIcon />
                </div>
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default DiscountInput;
